import { getCookie } from './cookies';

export function needsSessionRefresh(signalCookieName) {
  return !getCookie(signalCookieName);
}
